module.exports = __webpack_public_path__ + "static/assets/3c20092903063da1188ed242f2ce318c.gif";